import React, {Component, FC, PropsWithChildren} from "react";
import {AppRoutes} from "./AppRoutes";
import {AuthContextEntry} from "./contexts/AuthContext";
import {AsyncStorage} from "./helpers/AsyncStorage";
import {IdleContextEntry} from "./contexts/IdleContext";
import {TeamViewerMessageBarEntry} from "./contexts/TeamViewerMessageBarContext";

const ShowLoader: FC<PropsWithChildren> = ({children}) => {
    if (window.location.pathname == "/") return null;
    return null;
};

export default class App extends Component<any, any> {
    static displayName = App.name;

    render() {
        return (
            <TeamViewerMessageBarEntry>
                <IdleContextEntry>
                    <AuthContextEntry storage={AsyncStorage}>
                        <ShowLoader/>
                        <AppRoutes/>
                    </AuthContextEntry>
                </IdleContextEntry>
            </TeamViewerMessageBarEntry>
        );
    }
}
